"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoSlider = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Slider = require("b2b-components/theme/components/Slider");
var _key = require("b2b-components/utils/key");
require("./LogoSlider.scss");
const SLIDER_PARAMS = {
  xs: {
    slidesPerGroup: 4,
    slidesPerView: 4,
    spaceBetween: 80
  },
  sm: {
    slidesPerGroup: 6,
    slidesPerView: 6,
    spaceBetween: 32
  },
  md: {
    slidesPerGroup: 8,
    slidesPerView: 8,
    spaceBetween: 32
  },
  lg: {
    slidesPerGroup: 10,
    slidesPerView: 10,
    spaceBetween: 32
  },
  default: {
    slidesPerGroup: 4,
    slidesPerView: 4,
    spaceBetween: 16
  }
};
var BREAKPOINTS = /*#__PURE__*/function (BREAKPOINTS) {
  BREAKPOINTS[BREAKPOINTS["xs"] = 576] = "xs";
  BREAKPOINTS[BREAKPOINTS["sm"] = 768] = "sm";
  BREAKPOINTS[BREAKPOINTS["md"] = 992] = "md";
  BREAKPOINTS[BREAKPOINTS["lg"] = 1200] = "lg";
  return BREAKPOINTS;
}(BREAKPOINTS || {});
const LogoSlider = _ref => {
  let {
    title,
    items
  } = _ref;
  if (items.length < 1) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-FooterLogoSlider"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-FooterLogoSlider-Content"
  }, title && /*#__PURE__*/_react.default.createElement("p", {
    className: "cds-FooterLogoSlider-Title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-FooterLogoSlider-Slider"
  }, /*#__PURE__*/_react.default.createElement(_Slider.Slider, (0, _extends2.default)({}, SLIDER_PARAMS.default, {
    breakpoints: {
      [BREAKPOINTS.xs]: SLIDER_PARAMS.xs,
      [BREAKPOINTS.sm]: SLIDER_PARAMS.sm,
      [BREAKPOINTS.md]: SLIDER_PARAMS.md,
      [BREAKPOINTS.lg]: SLIDER_PARAMS.lg
    },
    isAutoplay: true,
    isLoop: false,
    styleType: _Slider.SLIDER_STYLE_TYPE.withMargin
  }), items.map((item, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: (0, _key.createKey)(index),
    className: "cds-FooterLogoSlider-Slider-Slide"
  }, item))))));
};
exports.LogoSlider = LogoSlider;
//# sourceMappingURL=LogoSlider.js.map